<script setup lang="ts">
const { defineOgMeta } = useSeoAttributes()
const pageMeta = usePageMeta()
const articlesFetch = useArticles()
const {
  public: { baseUrl },
} = useRuntimeConfig()
const [{ data: meta }, { data: articles }] = await Promise.all([
  useAsyncData('blog-meta', async () => pageMeta.fetchByPath('/blog')),
  useAsyncData('blog-page', async () => articlesFetch.fetch()),
])

if (meta.value) {
  useHead(() => ({
    title: meta?.value?.title || '',
    titleTemplate: '%s | Webamboos',
    meta: [...defineOgMeta(meta?.value)],
    link: [{ rel: 'canonical', href: `${baseUrl}/blog` }],
  }))
}
</script>

<template>
  <Container class="screen-content min-h-screen px-0 pb-32 md:px-16">
    <div v-if="articles">
      <LayoutPageHeader :title="$t('blog.title')" class="z-0" />

      <section v-if="articles.rest" class="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        <LargeArticlePreview v-if="articles.first" :article="articles.first" class="relative sm:col-span-2" />
        <ArticlePreview v-for="article of articles.rest" :key="article.slug" :article="article" />
      </section>
    </div>
  </Container>
</template>
